import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '../ui/Card';
import { Calendar } from 'lucide-react';

const ActivityHeatmap = ({ data = [] }) => {
  const generateHeatmapData = () => {
    const days = [];
    const today = new Date();
    
    // Create a map of dates to values from API data
    const dataMap = {};
    data.forEach(item => {
      if (item.date) {
        const dateKey = new Date(item.date).toDateString();
        dataMap[dateKey] = parseInt(item.completed) || 0;
      }
    });
    
    // Generate 28 days of data
    for (let i = 27; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(date.getDate() - i);
      const dateKey = date.toDateString();
      const value = dataMap[dateKey] || 0;
      days.push({
        value,
        label: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
      });
    }
    return days;
  };

  const heatmapData = generateHeatmapData();
  const maxValue = Math.max(...heatmapData.map(d => d.value), 1) || 1;
  
  const getColor = (value) => {
    const intensity = value / maxValue;
    if (intensity === 0) return '#f3f4f6';
    if (intensity > 0.75) return '#10b981';
    if (intensity > 0.5) return '#34d399';
    if (intensity > 0.25) return '#6ee7b7';
    return '#d1fae5';
  };

  return (
    <Card className="border border-gray-200 bg-white">
      <CardContent className="p-3">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center space-x-2">
            <div className="p-1 rounded bg-green-50">
              <Calendar className="w-3.5 h-3.5 text-green-600" />
            </div>
            <h3 className="text-xs font-semibold text-gray-700">Activity Heatmap (28 Days)</h3>
          </div>
          <div className="flex items-center space-x-1.5 text-[9px] text-gray-500">
            <span>Less</span>
            {[0, 0.33, 0.66, 1].map((intensity, i) => (
              <div 
                key={i} 
                className="w-2.5 h-2.5 rounded-sm" 
                style={{ backgroundColor: getColor(intensity * maxValue) }} 
              />
            ))}
            <span>More</span>
          </div>
        </div>
        <div className="grid grid-cols-7 gap-1">
          {heatmapData.map((item, index) => (
            <div 
              key={index} 
              className="relative group"
            >
              <div
                className="w-5 h-5 rounded-sm transition-opacity duration-200 cursor-pointer"
                style={{ backgroundColor: getColor(item.value) }}
              />
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-1.5 py-0.5 bg-gray-900 text-white text-[9px] rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none z-10">
                {item.label}: {item.value}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityHeatmap;
